<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <form class="mb-9">
                <div class="row justify-content-between align-items-end g-3 mb-5">
                    <div class="col-12 col-sm-auto col-xl-10">
                        <h2 class="mb-0" v-if="modo == 'Create'">New Sale Contact</h2>
                        <h2 class="mb-0" v-else >Edit Sale Contact</h2>
                    </div>
                    <div class="col-12 col-sm-auto col-xl-2">
                        <div class="d-flex">
                            <button @click="setData()" type="button" class="btn btn-primary px-5 w-100 text-nowrap">Save</button>
                        </div>
                    </div>
                </div>
                <div class="row g-5">
                    
                    <div class="col-xl-12">
                        <div class="row gx-3 gy-4">
                            <div class="col-sm-12 col-md-6">
                                <div class="form-floating">
                                    <input class="form-control" v-model="sales.name" type="text" placeholder="Name" />
                                    <label for="floatingEventInput">Name</label>
                                </div>
                            </div>  
                            <div class="col-sm-12 col-md-6">
                                <div class="form-floating">
                                    <input class="form-control" v-model="sales.whatsapp" type="text" placeholder="Whatsapp" />
                                    <label for="floatingEventInput">Whatsapp</label>
                                </div>
                            </div>  
                            <div class="col-sm-12 col-md-6">
                                <div class="form-floating">
                                    <input class="form-control" v-model="sales.phone" type="text" placeholder="Phone" />
                                    <label for="floatingEventInput">Phone</label>
                                </div>
                            </div>  
                          
                            <div class="col-sm-12 col-md-6">
                                <div class="form-floating">
                                    <textarea class="form-control" v-model="sales.location" rows="5" placeholder="Location" ></textarea>
                                    <label for="floatingEventInput">Location</label>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
import SideBar from '@/components/SideBarNav.vue'
import TopBar from '@/components/TopBarNav.vue'
import axios from 'axios'
export default {
    name:'SalesAdminComponent',
    components:{SideBar,TopBar},
    data(){
        return{
            sales: {},
            imageChanged: false,
            modo: this.$route.params.id > 0 ? 'Edit' : 'Create',
            images:{
                featured:'/assets/no-image.png'
            }
        }
    },
    created(){
        if(this.$route.params.id){
            this.getData()
        }
    },
    methods:{
        getData(){
             axios.get(this.$url+'/sale/'+this.$route.params.id, {
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            }).then((res)=>{
                this.sales = res.data
            })
        },
        setData(){
           
            axios.post(this.$url+(this.modo == 'Create' ? '/sales' : '/sales/'+this.$route.params.id), this.sales,{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            }).then(()=>{
                this.$router.push({name: 'sales'})
            })
        },
      
    }
}
</script>